import React from "react";
import "./footer.css";
const Footer = () => {
  return <div className=" footer absolute-center">Made with 🔥 by Nikhil</div>;
};

export default Footer;
